import { AppShell } from './src/AppShell.js';


window.customElements.define('app-shell', AppShell);
